/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_InformationInputs */

const en_common_information = /** @type {(inputs: Common_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information`)
};

const fr_common_information = /** @type {(inputs: Common_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information`)
};

const de_common_information = /** @type {(inputs: Common_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information`)
};

const it_common_information = /** @type {(inputs: Common_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni`)
};

const ru_common_information = /** @type {(inputs: Common_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Информация`)
};

const es_common_information = /** @type {(inputs: Common_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información`)
};

const zh_cn2_common_information = /** @type {(inputs: Common_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`信息`)
};

const ja_common_information = /** @type {(inputs: Common_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`情報`)
};

const hi_common_information = /** @type {(inputs: Common_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जानकारी`)
};

const pt_pt2_common_information = /** @type {(inputs: Common_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informação`)
};

/**
* | output |
* | --- |
* | "Information" |
*
* @param {Common_InformationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const common_information = /** @type {((inputs?: Common_InformationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_InformationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_common_information(inputs)
	if (locale === "de") return de_common_information(inputs)
	if (locale === "it") return it_common_information(inputs)
	if (locale === "ru") return ru_common_information(inputs)
	if (locale === "es") return es_common_information(inputs)
	if (locale === "zh-CN") return zh_cn2_common_information(inputs)
	if (locale === "ja") return ja_common_information(inputs)
	if (locale === "hi") return hi_common_information(inputs)
	if (locale === "pt-PT") return pt_pt2_common_information(inputs)
	return en_common_information(inputs)
});